module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/17c87f84cd427b624fad0fe085015075.png";